<h2 mat-dialog-title>Powód wycofania karty</h2>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Uwagi</mat-label>
    <input matInput autocomplete="off" type="text" [(ngModel)]="remarks" />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button color="warn" (click)="dialogRef.close(false)">Anuluj</button>
  <button mat-button (click)="confirm()" [disabled]="working">Potwierdź</button>
</div>
